import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import CarteiraRow from './CarteiraRow';
import CarteiraRFRow from './CarteiraRFRow';

class Carteira extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            carteira: {},
            modalidade: [],
            active: 'ACAO',
            orderBy: 'nome_asc',
            listaOrdem: [
                {id: 'nome_asc', nome: 'Nome /'},
                {id: 'nome_desc', nome: 'Nome \\'},
                {id: 'lucro_asc', nome: 'Lucro /'},
                {id: 'lucro_desc', nome: 'Lucro \\'},
                {id: 'saldo_asc', nome: 'Saldo /'},
                {id: 'saldo_desc', nome: 'Saldo \\'},
                {id: 'diferenca_asc', nome: 'Diferença /'},
                {id: 'diferenca_desc', nome: 'Diferença \\'},
            ],
        };
    }

    componentDidMount = async () => {
        await this.atualizarCarteira();
    }

    atualizarCarteira = async () => {
        try {
            const res = await axios.get(`${ambiente.dev.server}/carteira`);
            this.setState({ carteira: res.data });
            this.setState({ modalidade: res.data.acoes });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    atualizarCotacoes = async () => {
        try {
            await axios.get(`${ambiente.dev.server}/carteira/atualizarCotacao`);
            setTimeout(console.log('atualizando carteira'), 5000);
            await this.atualizarCarteira();
            this.props.exibirMensagem('info', `Carteira Atualizada`);
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    handleAlterarOrdenacaoFiltro = async (evt) => {
        await this.setState({ orderBy : evt.target.value });
        this.ordenarModalidade();
    }

    ordenarModalidade = () => {
        const modalidade = Object.assign({}, this.state.modalidade)
        modalidade.lista.sort((a, b) => {
            switch(this.state.orderBy) {
                case 'nome_desc': return b.ativo.localeCompare(a.ativo);
                case 'nome_asc': return a.ativo.localeCompare(b.ativo);
                case 'lucro_asc': return a.percentualTotal - b.percentualTotal;
                case 'lucro_desc': return b.percentualTotal - a.percentualTotal;
                case 'saldo_asc': return a.saldo - b.saldo;
                case 'saldo_desc': return b.saldo - a.saldo;
                case 'diferenca_asc': return a.diferencaValor - b.diferencaValor;
                case 'diferenca_desc': return b.diferencaValor - a.diferencaValor;
                default: return 0;
            }
        });
        this.setState({ modalidade });
    }

    handleAcoesClicked = async () => {
        await this.setState({ active: 'ACAO' });
        this.setState({ modalidade: this.state.carteira.acoes });
        this.ordenarModalidade();
    }
    
    handleFIIClicked = async () => {
        await this.setState({ active: 'FII', modalidade: this.state.carteira.fiis });
        this.ordenarModalidade();
    }
    
    handleTDClicked = async () => {
        await this.setState({ active: 'TD' });
        this.setState({ modalidade: this.state.carteira.td });
        this.ordenarModalidade();
    }
    
    handleRFClicked = async () => {
        await this.setState({ active: 'RF' });
        this.setState({ modalidade: this.state.carteira.rfixa });
        this.ordenarModalidade();
    }
    
    render() {
        return (
            <div>
                <div className="row">
                    <div className="form-group col-2">
                        <select className="form-control" value={this.state.orderBy} onChange={this.handleAlterarOrdenacaoFiltro}>
                            {this.state.listaOrdem.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                </div>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a className={`nav-link ${this.state.active === 'ACAO'? 'active': ''}`} onClick={this.handleAcoesClicked}>Ações</a>
                    </li>
                    <li className="nav-item">
                    <a className={`nav-link ${this.state.active === 'FII'? 'active': ''}`} onClick={this.handleFIIClicked}>FIIs</a>
                    </li>
                    <li className="nav-item">
                    <a className={`nav-link ${this.state.active === 'TD'? 'active': ''}`} onClick={this.handleTDClicked}>TDireto</a>
                    </li>
                    <li className="nav-item">
                    <a className={`nav-link ${this.state.active === 'RF'? 'active': ''}`} onClick={this.handleRFClicked}>RFixa</a>
                    </li>
                </ul>
                <div className="list-group">
                    {this.state.modalidade.lista && (
                        this.state.active === 'RF'? 
                            this.state.modalidade.lista.map(item => <CarteiraRFRow key={item.ativo} {...item}/>) :
                            this.state.modalidade.lista.map(item => <CarteiraRow key={item.ativo} {...item}/>) )}
                    <li className="list-group-item list-group-item-action flex-column align-items-start"> 
                        <div className="d-flex w-100 justify-content-between">
                            <h3>{parseFloat(this.state.modalidade.saldo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</h3>
                            <small>{parseFloat(this.state.modalidade.investimento).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                            <small>{parseFloat(this.state.modalidade.diferenca).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                            <h3>{(parseFloat(this.state.modalidade.rentabilidade)*100).toFixed(2)}%</h3>
                        </div>
                    </li>
                </div>
                <button type="button" className="btn btn-primary btn-block" onClick={this.atualizarCotacoes}>
                    Atualizar Cotações
                </button>
            </div>
        );
    }
}

Carteira.propTypes = {
    exibirMensagem: PropTypes.func.isRequired,
  };
  
  function mapStateToProps(state) {
    return {
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto)),
    };
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Carteira);


// WEBPACK FOOTER //
// ./src/components/carteira/Carteira.js